<template>
  <div class="content">
    <div class="topnav">
      <div class="width_1200">
        <div
          :style="{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            background: scrollY > 0 ? '#ffffff' : '#3151f9',
            zIndex: 99,
          }"
          :class="scrollY > 0 ? 'color' : ''"
        >
          <nav :class="{ width: 1061 + 'px', margin: 'auto' }">
            <div class="logo">
              <img
                src="../assets/lll.png"
                alt=""
                :style="{ width: 97 + 'px', height: 26 + 'px' }"
                v-if="scrollY > 0"
              />
              <img
                src="../assets/logo.png"
                alt=""
                :style="{ width: 97 + 'px', height: 26 + 'px' }"
                v-else
              />
              <span :style="{ margin: '0 ' + 15 + 'px' }">|</span>
              <span :style="{ fontWeight: scrollY > 0 ? 'bold' : '' }"
                >护士（师）资格考试</span
              >
            </div>
            <ul>
              <li @click="goDom('#serviceID')">报考指南</li>
              <li @click="goDom('#prepareID')">考试总览</li>
              <li @click="goDom('#knowID')">备考专区</li>
              <li @click="goDom('#carouselID')">教学课程</li>
              <li @click="goDom('#wmImgID')">关于沃米</li>
            </ul>
            <div class="dropdownBtn">
              <el-dropdown>
                <el-button class="button">
                  全部分类<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>初级护师培训</el-dropdown-item>
                  <el-dropdown-item>主管护师培训</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="phone">
                <img
                  src="../assets/phonee.png"
                  alt=""
                  :style="{
                    width: 16 + 'px',
                    height: 16 + 'px',
                    marginRight: 5 + 'px',
                    marginLeft: 15 + 'px',
                  }"
                  v-if="scrollY > 0"
                />
                <img
                  src="../assets/phone.png"
                  alt=""
                  :style="{
                    marginRight: -8 + 'px',
                    marginLeft: 15 + 'px',
                  }"
                  v-else
                />
                <span>010-61705656</span>
              </div>
            </div>
          </nav>
        </div>
        <div class="top_info">
          <div class="Left_">
            <div class="Lefft_but" @click="goCeping"></div>
          </div>
          <div class="left">
            <div class="bt">
              <span>2024年</span>
              <span>沃米护考网</span>
            </div>
            <img
              src="../assets/title.png"
              alt=""
              :style="{ width: 764 + 'px', height: 190 + 'px' }"
            />
            <img
              src="../assets/tips.png"
              :style="{
                marginLeft: 20 + 'px',
                width: 75 + 'px',
                height: 26 + 'px',
              }"
              alt=""
            />
            <p>护士（师）资格考试改革在即，一键掌握全新报考信息</p>
            <div class="btns">
              <div @click="goMessage" id="hoverColor">政策改革咨询</div>
              <div @click="goMessage" id="hoverColor">报考条件查询</div>
              <div @click="goMessage" id="hoverColor">精品资料下载</div>
            </div>
          </div>
          <div class="right">
            <img src="../assets/person.png" alt="" />
          </div>
        </div>
        <div class="service prepare" :style="{ marginTop: 110 + 'px' }">
          <span class="prepare_text" id="serviceID"
            >2024年护士(师)资格考试信息咨询专区</span
          >
          <div class="prepare_border"><div></div></div>
          <div class="service_info">
            <div class="left">
              <div class="left_top">
                <div class="border_bt">
                  <span>考试报名指导服务</span>
                  <img
                    src="../assets/icon1.png"
                    alt=""
                    :style="{ width: 26 + 'px', height: 26 + 'px' }"
                  />
                </div>
                <div class="left_top_btn">
                  <div @click="goMessage" id="buttonColor">报考条件查询</div>
                  <div @click="goMessage" id="buttonColor">
                    网上协助报名入口
                  </div>
                </div>
              </div>
              <div class="guidance">
                <div class="guidance_bt">
                  <span>考试报名指导服务</span>
                  <div @click="goMessage">
                    <span>点击咨询</span>
                    <i class="el-icon-right"></i>
                  </div>
                </div>
                <div class="menu_btn">
                  <div
                    @click="goMessage"
                    class="menu_btn_item"
                    v-for="(item, index) in guidanceList"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div class="center">
              <div class="border_bt">
                <span>考试报名指导服务</span>
                <img
                  src="../assets/icon2.png"
                  alt=""
                  :style="{ width: 26 + 'px', height: 26 + 'px' }"
                />
              </div>
              <div class="answer_box" @click="goMessage">
                <div
                  class="answer_item"
                  v-for="(item, index) in answerList"
                  :key="index"
                >
                  {{ item.text }}
                  <img
                    src="../assets/hot.png"
                    v-if="item.type == 1"
                    alt=""
                    :style="{ width: 15 + 'px', height: 18 + 'px' }"
                  />
                </div>
              </div>
            </div>
            <div class="right">
              <div class="border_bt">
                <span>资料专区 一键下载</span>
                <img
                  src="../assets/icon3.png"
                  alt=""
                  :style="{ width: 26 + 'px', height: 26 + 'px' }"
                />
              </div>
              <div class="load_box">
                <div
                  class="load_item"
                  v-for="(item, index) in loadList"
                  :key="index"
                >
                  <img
                    :src="item.img"
                    alt=""
                    :style="{ width: 22 + 'px', height: 23 + 'px' }"
                  />
                  <span>{{ item.title }}</span>
                </div>
              </div>
              <div class="from_box">
                <div>
                  <span>姓名：</span>
                  <input
                    type="text"
                    placeholder="请输入您的姓名"
                    v-model="nameValue"
                  />
                </div>
                <div>
                  <span>电话：</span>
                  <input
                    type="text"
                    placeholder="请输入您的联系方式"
                    v-model="phoneValue"
                  />
                </div>
                <div>
                  <span>邮箱：</span>
                  <input
                    type="text"
                    placeholder="填写正确邮箱接收资料"
                    v-model="msgValue"
                  />
                </div>
                <el-button
                  id="buttonColor"
                  type="primary"
                  class="fromBtn"
                  @click="goSubmit"
                  >一键领取</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="query">
        <span class="query_text1"
          >2024年执业护士(师)资格证报考条件审核查询系统</span
        >
        <span class="query_text2"
          >注:系统审核流程将于10分钟内完成，稍后我们会以短信或语音形式通知您审核结果</span
        >
        <div class="query_input">
          <div class="select_">
            <div class="select_div">
              <el-select v-model="province" placeholder="所有省份">
                <el-option
                  v-for="item in provinceOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_div">
              <el-select v-model="province1" placeholder="最高学历">
                <el-option
                  v-for="item in provinceOption1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_div">
              <el-select v-model="province2" placeholder="工作年限">
                <el-option
                  v-for="item in provinceOption2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="select_phone">
            <el-input v-model="phone" placeholder="手机号码"></el-input>
            <el-button id="buttonColor" @click="goSubmit('获取查询信息')"
              >获取查询信息</el-button
            >
          </div>
        </div>
      </div>
      <!-- 备战护师考试资格，不了解的事 -->
      <div class="width_1200 prepare">
        <span id="prepareID" class="prepare_text"
          >备战护士资格考试，你不得不了解的那些事！</span
        >
        <div class="prepare_border"><div></div></div>
        <div class="prepare_content">
          <div
            class="synopsis_left div"
            :style="{ paddingLeft: 15 + 'px' }"
          >
            <div class="synopsis_left-box">
              <div class="box_imgT">
                <img src="../assets/aptitudes.png" alt="" />
                <div class="span">
                  <span>报名条件</span>
                  <span>资质审核</span>
                </div>
              </div>
              <div
                id="box_bottom2"
                class="box_bottom"
                style="color: #4fd34a"
                @click="goMessage"
              >
                <span>审核条件</span>
              </div>
            </div>
            <div class="synopsis_left_border"></div>
            <div class="synopsis_left-box">
              <div class="box_imgT">
                <img src="../assets/location.png" alt="" />
                <div class="span">
                  <span>报名条件</span>
                  <span>报名地点</span>
                </div>
              </div>
              <div
                id="box_bottom1"
                class="box_bottom"
                style="color: #ffad3c"
                @click="goMessage"
              >
                <span>确认时间</span>
              </div>
            </div>
            <div class="synopsis_left_border"></div>
            <div class="synopsis_left-box">
              <div class="box_imgT">
                <img src="../assets/unscramble.png" alt="" />
                <div class="span">
                  <span>考试大纲</span>
                  <span>名师解读</span>
                </div>
              </div>
              <div
                id="box_bottom3"
                class="box_bottom"
                style="color: #1cb2f2"
                @click="goMessage"
              >
                <span>考试范围</span>
              </div>
            </div>
            <div class="synopsis_left-box">
              <div class="box_imgT">
                <img src="../assets/subject.png" alt="" />
                <div class="span">
                  <span>考试时间</span>
                  <span>考试科目</span>
                </div>
              </div>
              <div
                id="box_bottom4"
                class="box_bottom"
                style="color: #fe5e70"
                @click="goMessage"
              >
                <span>考试安排</span>
              </div>
            </div>
            <div class="synopsis_left_border"></div>
            <div class="synopsis_left-box">
              <div class="box_imgT">
                <img src="../assets/ review.png" alt="" />
                <div class="span">
                  <span>全新教材</span>
                  <span>复习资料</span>
                </div>
              </div>
              <div
                id="box_bottom3"
                class="box_bottom"
                style="color: #1cb2f2"
                @click="goMessage"
              >
                <span>新版教材</span>
              </div>
            </div>
            <div class="synopsis_left_border"></div>
            <div
              class="synopsis_left-box"
              :style="{ marginLeft: 19 + 'px' }"
            >
              <div class="box_imgT">
                <img src="../assets/reference.png" alt="" />
                <div class="span">
                  <span>学习周期</span>
                  <span>备考方案</span>
                </div>
              </div>
              <div
                id="box_bottom1"
                class="box_bottom"
                style="color: #ffad3c"
                @click="goMessage"
              >
                <span>制定学习计划</span>
              </div>
            </div>
          </div>
          <div class="synopsis_right div">
            <span class="synopsis_right_title"
              >2024护士(师)资格证   各地区报考条件及考点查询</span
            >
            <div class="synopsis_right_content">
              <div class="_content_left">
                <div class="_content_left_box">
                  <div class="_left_box">
                    <img src="../assets/caution.png" alt="" />
                    <span>报名条件提醒</span>
                  </div>
                  <span class="_left_text">
                    部分地区<span style="color: red">报名条件不同</span
                    >，请<span style="color: red">提前确认</span
                    >所在地报考要求，避免无法报考。
                  </span>
                </div>
                <el-input
                  v-model="input"
                  placeholder="请输入您的手机号"
                ></el-input>
                <el-button @click="goSubmit('一键查询')" id="buttonColor"
                  >一键查询</el-button
                >
              </div>
              <div class="_content_right">
                <!-- _right_text_option 选中变量名 -->
                <div
                  v-for="(item, index) in addr"
                  :key="index"
                  @click="addrName(item)"
                  :class="aNmae == item ? '_right_text_option' : '_right_text'"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 考试简介 -->
      <div class="width_1200 prepare">
        <span class="prepare_text">2024年护士(师)执业资格证【考试简介】</span>
        <span class="prepare_minText"
          >护士执业资格考试是评价申请者是否具备所须护理知识与能力的考试，是单位聘任相应职务的必要依据</span
        >
        <div class="prepare_border"><div></div></div>
        <div class="prepare_content">
          <div class="left div">
            <div class="left_title">
              <span>护士职业发展前景分析</span>
              <img src="../assets/vista.png" alt="" />
            </div>
            <div class="left_box">
              <div class="circle">01</div>
              <div class="left_box_text">
                <span>人才紧缺</span>
                <span
                  >《“健康中国2030”规划纲要》提出，到2030年，我国还差约300万护士缺口。</span
                >
              </div>
            </div>
            <img
              src="../assets/jiantou.png"
              alt=""
              :style="{
                height: 23 + 'px',
                marginTop: 5 + 'px',
                width: 25 + 'px',
              }"
            />
            <div class="left_box_right">
              <div class="left_box_text">
                <span>行业前景</span>
                <span
                  >我国正向老龄化社会转变，未来保健医师、家庭护士将成为热门人才。</span
                >
              </div>
              <div class="circle">02</div>
            </div>
            <img
              src="../assets/jiantou.png"
              alt=""
              :style="{
                height: 23 + 'px',
                marginTop: 5 + 'px',
                width: 25 + 'px',
              }"
            />
            <div class="left_box" :style="{ marginTop: 5 + 'px' }">
              <div class="circle">03</div>
              <div class="left_box_text">
                <span>就业选择</span>
                <span
                  >护理领域可从事临床护理、预防保健、护理管理、护理教学、科研等工作；医疗、美容、制药行业均可就业。</span
                >
              </div>
            </div>
            <img
              src="../assets/jiantou.png"
              alt=""
              :style="{
                height: 23 + 'px',
                marginTop: 5 + 'px',
                width: 25 + 'px',
              }"
            />
            <div class="left_box_right">
              <div class="left_box_text">
                <span>发展空间</span>
                <span
                  >护士→护师→主管护师→副主任护师→主任护师晋升管理层，<span
                    :style="{
                      color: 'red',
                      fontSize: 12 + 'px',
                      fontWeight: 400,
                    }"
                    >高薪资、高自由度。</span
                  ></span
                >
              </div>
              <div class="circle">04</div>
            </div>
          </div>
          <div class="right div">
            <div class="right_div_title">01报考条件审核</div>
            <div class="right_div_title-li">
              <span style="width: 30%">学历</span>
              <span style="width: 30%">专业</span>
              <span style="width: 40%">工作经验</span>
            </div>
            <div class="right_div_title-li">
              <span style="width: 30%">全日制中专及以上学历</span>
              <span style="width: 30%">护理、助产专业</span>
              <span
                title="教学、综合医院8个月以上护理临床实习"
                style="width: 40%"
                >教学、综合医院8个月以上护理临床实习</span
              >
            </div>
            <div
              class="right_div_title"
              :style="{ marginTop: 30 + 'px' }"
            >
              02 考试安排
            </div>
            <div class="right_div_title-li">
              <span style="width: 15%">考试科目</span>
              <span style="width: 24%">考试时间</span>
              <span style="width: 15%">考试形式</span>
              <span style="width: 23%">考试题型</span>
              <span style="width: 23%">合格标准</span>
            </div>
            <div class="right_div_title-li">
              <span style="width: 15%">专业实务</span>
              <span style="width: 24%">2024年4月27日~28日</span>
              <span style="width: 15%">人机对话</span>
              <span style="width: 23%">120题/100分钟</span>
              <span style="width: 23%">300及格（总分380）</span>
            </div>
            <div class="right_div_title-li">
              <span style="width: 15%">实践能力</span>
              <span style="width: 24%">2024年4月27日~28日</span>
              <span style="width: 15%">人机对话</span>
              <span style="width: 23%">120题/100分钟</span>
              <span style="width: 23%">300及格（总分380）</span>
            </div>

            <div class="right_div_promit">
              <span>2024年护考考试温馨提示：</span>
              <span
                >01）考试时间缩短：由原来的纸笔作答120分钟，变为人机对话100分钟；护士素养提升+医院接触的外国人增多，英语将作为备考科目</span
              >
              <span
                >02）人机对话禁止跳转问题：专业实务和实践能力两个科目题型均为选择题，包括A1\A2和A3\A4型题，只要点击进入A2题型，就不能对A1题型中的作答进行修改。</span
              >
            </div>
            <el-button
              id="buttonColor"
              :style="{ marginLeft: 193 + 'px' }"
              @click="goMessage"
              >查看历年考试题</el-button
            >
            <el-button
              id="buttonColorb"
              :style="{ marginLeft: 68 + 'px' }"
              @click="goMessage"
              >护师报考条件查询</el-button
            >
          </div>
        </div>
      </div>
      <!-- conditions 报考条件不符合怎么办 -->
      <div class="width_1200 conditions prepare">
        <span class="prepare_text">报考条件不符合怎么办？</span>
        <div class="prepare_border"><div></div></div>
        <div class="conditions_content">
          <div>
            <img src="../assets/condition1.png" alt="" />
            <div class="_con_div">
              <span>学历</span>
            </div>
            <span class="_con_span"
              >中等专科以上学历如何判断？自考、成考（脱产、业余（夜大）、函授）网络教学等，这些学历符合报考要求吗？</span
            >
            <el-button @click="goMessage" id="buttonColorb">确认学历</el-button>
            <span class="_con_spanlast"
              >学历不够解决方案<span @click="goMessage">点击咨询</span></span
            >
          </div>
          <div>
            <img src="../assets/condition2.png" alt="" />
            <div class="_con_div">
              <span>专业</span>
            </div>
            <span class="_con_span"
              >相应专业有哪些？基础医学类、法医学类、护理学类、辅助医疗类、医学技术类等相关医学类和药学类、医学管理类能考吗？</span
            >
            <el-button @click="goMessage" id="buttonColorb"
              >报考专业一览表</el-button
            >
            <span class="_con_spanlast"
              >专业不符解决方案<span @click="goMessage">点击咨询</span></span
            >
          </div>
          <div>
            <img src="../assets/condition3.png" alt="" />
            <div class="_con_div">
              <span>工作年限</span>
            </div>
            <span class="_con_span"
              >在教学、综合医院完成8个月以上护理临床实习，什么时候算起？上学期间实习期算吗？</span
            >
            <el-button @click="goMessage" id="buttonColorb"
              >统计工作年限</el-button
            >
            <span class="_con_spanlast"
              >年限不够解决方案<span @click="goMessage">点击咨询</span></span
            >
          </div>
          <img
            src="../assets/conditions.png"
            alt=""
            @click="service(1)"
            style="cursor: pointer"
          />
        </div>
      </div>
      <!-- 护考人banner -->
      <div class="guard">
        <div class="width_1200">
          <img src="../assets/Tbannner.png" alt="" />
          <el-button @click="service(1)" id="buttonColor">立即申请</el-button>
        </div>
      </div>
	  
      <!-- 懂教育 -->
      <div class="width_1200 prepare">
        <span id="knowID" class="prepare_text"
          >懂教育 更懂应试 每次浓缩 只为更"薄"一点</span
        >
        <span class="prepare_minText"
          >沃米护考——特色周周手札~五维考点速记~导图导学 助力一次通关</span
        >
        <div class="prepare_border"><div></div></div>
        <div class="know">
          <img src="../assets/knowImg.png" alt="" class="knowimg" />
          <div class="know_good">
            <span class="_good_title">五维考点速记 六大优势</span>
            <div class="_good_ul">
              <div class="_good_ul_li"><div>1</div></div>
              <div class="_good_ul_span">
                <span style="color: rgba(253, 255, 0, 1)">2880</span
                >个大纲考点，科学浓缩为<span style="color: rgba(253, 255, 0, 1)"
                  >1440</span
                >个必考考点
              </div>
            </div>
            <div class="_good_ul">
              <div class="_good_ul_li"><div>2</div></div>
              <div class="_good_ul_span">
                漏斗学习配套真题、点睛、冲刺、押题科学备考
              </div>
            </div>
            <div class="_good_ul">
              <div class="_good_ul_li"><div>3</div></div>
              <div class="_good_ul_span">
                <span style="color: rgba(253, 255, 0, 1)">200</span
                >个重难点题目视频解析，快速掌握考点点
              </div>
            </div>
            <div class="_good_ul">
              <div class="_good_ul_li"><div>4</div></div>
              <div class="_good_ul_span">
                优创分册编排，漏斗式学习；合理分层
              </div>
            </div>
            <div class="_good_ul">
              <div class="_good_ul_li"><div>5</div></div>
              <div class="_good_ul_span">
                名师一笔一磨砺，浓缩<span style="color: rgba(253, 255, 0, 1)"
                  >90%</span
                >考点
              </div>
            </div>
            <div class="_good_ul">
              <div class="_good_ul_li"><div>6</div></div>
              <div class="_good_ul_span" style="border: none">
                漫画图解技巧易记忆，化繁为简，启迪智慧
              </div>
            </div>
          </div>
          <div class="know_book">
            <img src="../assets/book.png" alt="" />
            <div class="_book_span">
              <span>沃米模拟考卷</span>
              <span>高频考点~口袋书</span>
              <span>五维考点速记—高教版</span>
              <span>周周手札~手绘图解</span>
              <span>五维速记导图</span>
            </div>
            <div class="_book_but">
              <div>
                <el-button @click="service(0)" id="buttonColor"
                  >电子版下载</el-button
                >
                <el-button @click="goMessage" id="buttonColorb"
                  >索取纸质版</el-button
                >
              </div>
              <div>
                <el-button @click="service(0)" id="buttonColor"
                  >电子版下载</el-button
                >
                <el-button @click="goMessage" id="buttonColorb"
                  >索取纸质版</el-button
                >
              </div>
              <div>
                <el-button @click="service(0)" id="buttonColor"
                  >电子版下载</el-button
                >
                <el-button @click="goMessage" id="buttonColorb"
                  >索取纸质版</el-button
                >
              </div>
              <div>
                <el-button @click="service(0)" id="buttonColor"
                  >电子版下载</el-button
                >
                <el-button @click="goMessage" id="buttonColorb"
                  >索取纸质版</el-button
                >
              </div>
              <div>
                <el-button @click="service(0)" id="buttonColor"
                  >电子版下载</el-button
                >
                <el-button @click="goMessage" id="buttonColorb"
                  >索取纸质版</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 备考题库 -->
      <div class="width_1200 prepare">
        <span class="prepare_text">2024护士执业资格考试—备考题库</span>
        <span class="prepare_minText"
          >内部资料配合网校课程一起学习，备考效率提高49%</span
        >
        <div class="prepare_border"><div></div></div>
        <div class="reference">
          <div class="reference-left">
            <span class="_left_title_">专业师资授课 备考不走弯路</span>
            <span class="title">共性课程</span>
            <div></div>
            <span
              :class="videoType == 1 ? 'option error' : 'error'"
              @click="videoTab(1)"
              >2024 基础护理知识和技能视频课</span
            >
            <div></div>
            <span
              :class="videoType == 2 ? 'option error' : 'error'"
              @click="videoTab(2)"
              >2024泌尿生殖系统视频课</span
            >
            <div></div>
            <span class="title">基础护理学</span>
            <div></div>
            <span
              :class="videoType == 3 ? 'option error' : 'error'"
              @click="videoTab(3)"
              >2024 基础护理知识和技能2</span
            >
            <div></div>
            <span class="title">呼吸体统、消化/循环系统解刨生理</span>
            <div></div>
            <span
              :class="videoType == 4 ? 'option error' : 'error'"
              @click="videoTab(4)"
              >呼吸系统解剖生理课</span
            >
            <div></div>
            <span class="title">考前冲刺专题</span>
            <div></div>
            <span
              :class="videoType == 5 ? 'option error' : 'error'"
              @click="videoTab(5)"
              >考前冲刺专题</span
            >
            <el-button @click="goMessage" id="buttonColor"
              >查看更多课程详情</el-button
            >
          </div>
          <div class="reference-right">
            <div
              :style="{
                width: 666 + 'px',
                height: 50 + 'px',
                background: '#ffffff',
                position: 'absolute',
                marginTop: 356 + 'px',
              }"
            ></div>
            <iframe
              class="video"
              :key="videourl"
              :src="videourl"
              scrolling="no"
              border="0"
              frameborder="no"
              framespacing="0"
              allowfullscreen="true"
              ref="video"
            >
            </iframe>
            <div class="_right_bottom">
              <div class="_bottom_title">近5年真题解析下载专区</div>
              <div class="_bottom_box">
                <div class="_box" @click="service(0)">
                  <img src="../assets/donw.png" alt="" />
                  <div>
                    <span>执业护士资格</span>
                    <span>模拟试题ZIP</span>
                  </div>
                </div>
                <div class="_box" @click="service(0)">
                  <img src="../assets/donw.png" alt="" />
                  <div>
                    <span>200道重难点</span>
                    <span>视频解析ZIP</span>
                  </div>
                </div>
                <div class="_box" @click="service(0)">
                  <img src="../assets/donw.png" alt="" />
                  <div>
                    <span>2024年全真</span>
                    <span>模拟考卷ZIP</span>
                  </div>
                </div>
                <div class="_box" @click="service(0)">
                  <img
                    src="../assets/donw.png"
                    alt=""
                    :style="{ marginLeft: 20 + 'px' }"
                  />
                  <div>
                    <span>护士执业资格</span>
                    <span>考试历年真题ZIP</span>
                  </div>
                </div>
                <div class="_box" @click="service(0)">
                  <img
                    src="../assets/donw.png"
                    alt=""
                    :style="{ marginLeft: 20 + 'px' }"
                  />
                  <div>
                    <span>2024年押题密卷</span>
                    <!-- <span>执业护士资格</span> -->
                  </div>
                </div>
                <div class="_box" @click="service(0)">
                  <img src="../assets/donw.png" alt="" />
                  <div>
                    <span>五维速记导图</span>
                    <span>周周手札</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 优选沃米 -->
      <div class="width_1200 prepare">
        <span id="wmImgID" class="prepare_text"
          >考取护士执业资格证书 优选沃米!</span
        >
        <div class="prepare_border"><div></div></div>
        <div class="wmImg">
          <img src="../assets/wmImg1.png" alt="" />
          <img src="../assets/wmImg2.png" alt="" />
          <img src="../assets/wmImg3.png" alt="" />
          <img src="../assets/wmImg4.png" alt="" />
        </div>
      </div>
      <!-- 值得信赖 -->
      <div class="width_1200 prepare">
        <span id="carouselID" class="prepare_text"
          >21年锤炼一支 师资队伍，去量存优 沃米值得信赖</span
        >
        <div class="prepare_border"><div></div></div>
        <div class="carousel">
          <div class="carousel_content">
            <div class="car_box">
              <el-carousel
                trigger="click"
                :autoplay="false"
                height="364px"
                ref="carousel"
              >
                <el-carousel-item
                  v-for="(item, index) in carousel"
                  :key="index"
                >
                  <div class="car_box_">
                    <div
                      class="car_box_left"
                      :style="{ background: 'url(' + item.img + ') no-repeat' }"
                    >
                      <div class="_box_name">
                        <span>{{ item.name }}</span>
                        <span>{{ item.nickname }}</span>
                      </div>
                    </div>
                    <div class="car_box_right">
                      <span class="_right_title">{{ item.course }}</span>
                      <div class="_right_span">
                        <img src="../assets/rightjt.png" alt="" />
                        <div>
                          <span>资历简介</span>
                          <span
                            v-for="(i, indexs) in item.zili"
                            :key="indexs"
                            >{{ i }}</span
                          >
                        </div>
                      </div>
                      <div class="_right_span">
                        <img src="../assets/rightjt.png" alt="" />
                        <div>
                          <span>授课风格</span>
                          <span>{{ item.fengge }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="car_bottom">
              <div
                v-for="(item, index) in Tcar"
                :key="index"
                class="car_bot_img1"
                :style="{
                  background: 'url(' + item.img + ') no-repeat',
                  backgroundSize: '100% 100%',
                }"
                @click="carImg(item.indexs)"
              >
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 全新版型搭配 -->
      <div class="width_1200 prepare">
        <span class="prepare_text">全新班型搭配，选择适合自己的课程!</span>
        <div class="prepare_border"><div></div></div>
        <div
          class="allNew"
          v-for="(item, index) in 4"
          :key="index"
          :style="{ marginTop: index == 0 ? 40 + 'px' : '' }"
        >
          <div :class="'allnew' + (index + 1)">
            <el-button @click="goMessage" id="buttonColor">购买全科</el-button>
          </div>
        </div>
      </div>
      <!-- 业余时间 -->
      <div class="width_1200 prepare">
        <span class="prepare_text"
          >我用业余时间学习，不为别的，只为活的体面些!</span
        >
        <div class="prepare_border"><div></div></div>
        <div class="lastdiv">
          <img src="../assets/lastimg1.png" alt="" />
          <img src="../assets/lastimg2.png" alt="" />
          <img src="../assets/lastimg3.png" alt="" />
        </div>
      </div>
      <!-- 底部 -->
      <div class="bottomBox"></div>
      <div class="width_1200 record">
        <div>
          <span>Copyright © 2014-2024华夏沃米（北京）教育科技有限公司</span>
          <span>地址：北京市昌平区沙河镇昌平路97号6幢703G</span>
        </div>
        <div>
          京ICP备18047046号-1<img
            src="../assets/badges.png"
            alt=""
          />京公网安备11011402010863号
        </div>
      </div>
      <!-- 左侧跟随条 -->
      <div class="follow">
        <div class="follow_top">
          <img src="../assets/follwoimg.png" alt="" />
          <div class="follow_span">
            <span @click="goMessage">报名时间提前</span>
            <span @click="goMessage">报考条件改革</span>
            <span @click="goMessage">考试信息动态</span>
            <span @click="goMessage">考试变动改革</span>
            <span @click="goMessage">新增考点查看</span>
            <span @click="goMessage">护资报名入口</span>
            <span @click="goMessage" style="border: none">新版大纲变动</span>
          </div>
        </div>
        <div class="follow_bottom" @click="goTop">
          <img src="../assets/goTop.png" alt="" />
          <span>回顶部</span>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :show-close="false"
      width="393px"
      :close-on-click-modal="false"
      :style="{ borderRadius: 12 + 'px', marginTop: 100 + 'px' }"
    >
      <div class="info_popup">
        <img
          src="../assets/off.png"
          alt=""
          class="off"
          @click="handleClose"
          :style="{
            marginTop: dialogVisibleType == 1 ? -20 + 'px' : '0px',
          }"
        />
        <img src="../assets/neibu.png" alt="" v-if="dialogVisibleType == 0" />
        <img src="../assets/neibu1.png" alt="" v-else />
        <span v-if="dialogVisibleType == 0" class="span"
          >累计已下载人数<span>3689</span></span
        >
        <span v-else class="span" style="background: none"
          >每期限100名额 累计已有<span>2689</span>预约报名</span
        >
        <input type="text" placeholder="您的姓名：" v-model="Mname" />
        <input type="text" placeholder="联系电话：" v-model="Mphone" />
        <input
          type="text"
          placeholder="您的邮箱："
          v-model="Memail"
          v-if="dialogVisibleType == 0"
        />
        <el-button @click="goSubmit('立即下载')" v-if="dialogVisibleType == 0"
          >立即下载</el-button
        >
        <el-button @click="goSubmit('立即下载1')" v-else
          >立即锁定名额</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisibleType: 1,
      guidanceList: [
        "报名时间",
        "报名入口",
        "考试大纲",
        "考试时间",
        "考试资料",
        "教材下载",
        "成绩查询",
        "考试科目",
        "证书领取",
      ],
      answerList: [
        { type: 1, text: "• 2024护士(师)考试全新升级课程火热招生，超前预热" },
        { type: 0, text: "• 2024年护士(师)资格考试报名指导！" },
        { type: 1, text: "• 2024护士(师)考试成绩查询一键订阅！" },
        { type: 0, text: "• 2024护士(师)考试考后复盘|考情分析直播" },
        { type: 0, text: "• 2024护士(师)历年真题考点精编限时0元免费抢" },
        { type: 0, text: "• 2024年执业护士人机考试是什么形式 ?" },
        { type: 0, text: "• 助产专业可以报考护士执业资格考试吗 ?" },
        { type: 0, text: "• 不同学历的工作年限报考护士执业考试是怎么计算的？" },
        { type: 1, text: "• 成考/函授/自考学历可以报名护士执业资格考试吗？" },
      ],
      loadList: [
        { img: require("../assets/load_icon1.png"), title: "往年真题" },
        { img: require("../assets/load_icon2.png"), title: "考试大纲" },
        { img: require("../assets/load_icon3.png"), title: "知识汇总" },
        { img: require("../assets/load_icon4.png"), title: "模拟题库" },
        { img: require("../assets/load_icon5.png"), title: "复习计划" },
        { img: require("../assets/load_icon6.png"), title: "难点梳理" },
        { img: require("../assets/load_icon7.png"), title: "视频课件" },
        { img: require("../assets/load_icon8.png"), title: "考点整理" },
      ],
      /* 省份 */
      province: "",
      provinceOption: [
        {
          value: "北京",
          label: "北京",
        },
        {
          value: "广东",
          label: "广东",
        },
        {
          value: "江苏",
          label: "江苏",
        },
        {
          value: "山东",
          label: "山东",
        },
        {
          value: "浙江",
          label: "浙江",
        },
        {
          value: "安徽",
          label: "安徽",
        },
        {
          value: "四川",
          label: "四川",
        },
        {
          value: "河南",
          label: "河南",
        },
        {
          value: "天津",
          label: "天津",
        },
        {
          value: "湖南",
          label: "湖南",
        },
        {
          value: "湖北",
          label: "湖北",
        },
        {
          value: "重庆",
          label: "重庆",
        },
        {
          value: "福建",
          label: "福建",
        },
        {
          value: "陕西",
          label: "陕西",
        },
        {
          value: "河北",
          label: "河北",
        },
        {
          value: "上海",
          label: "上海",
        },
        {
          value: "吉林",
          label: "吉林",
        },
        {
          value: "辽宁",
          label: "辽宁",
        },
        {
          value: "甘肃",
          label: "甘肃",
        },
        {
          value: "山西",
          label: "山西",
        },
        {
          value: "海南",
          label: "海南",
        },
        {
          value: "江西",
          label: "江西",
        },
        {
          value: "黑龙江",
          label: "黑龙江",
        },
      ],
      /* 学历 */
      province1: "",
      provinceOption1: [
        {
          value: "中专及高中",
          label: "中专及高中",
        },
        {
          value: "大专",
          label: "大专",
        },
        {
          value: "本科",
          label: "本科",
        },
        {
          value: "硕士",
          label: "硕士",
        },
        {
          value: "博士",
          label: "博士",
        },
      ],
      /* 年限 */
      province2: "",
      provinceOption2: [
        {
          value: "应届毕业生",
          label: "应届毕业生",
        },
        {
          value: "1-3年",
          label: "1-3年",
        },
        {
          value: "3-5年",
          label: "3-5年",
        },
        {
          value: "5-7年",
          label: "5-7年",
        },
        {
          value: "7年以上",
          label: "7年以上",
        },
      ],
      /* 手机号 */
      phone: "",
      input: "",
      carousel: [
        {
          img: require("../assets/zzTeacher.png"),
          name: "多巴胺老师",
          nickname: '人称"行走的多巴胺"',
          course: "经典课程：《沃米护考五维通关》",
          zili: [
            "沃米护考教学总监，著名医学院硕士，参与多部考试类图书的编写",
            "培训经验11年，课时累计超过12000小时",
            "研究护考考点和考题累计超20000小时",
            "学员累计超10万人，学员通过率高达97.6%",
			"2020年获得全国医学类“金牌讲师称号",
			"2021年获得“北京市文明青年”荣誉称号",
          ],
          fengge:
            "授课思路清晰、通俗易懂、风趣幽默，教学中擅于运用多种方法让考生记住重点、难点。",
        },
        {
          img: require("../assets/jjTeacher.png"),
          name: "洋洋老师",
          nickname: "",
          course: "经典课程:《沃米护考五维通关》",
          zili: [
            "沃米护考特聘讲师，人民大学硕士学位",
            "学员累计超过万人，通过率高达96.5%",
            "从事医学考试培训教学工作6年",
            "授课逻辑清晰、条理清楚、化繁为简、重点突出",
          ],
          fengge:
            "精准把握医学考试命题重点与考察方向，专业功底扎实，授课风格深入浅出，善于逻辑推导，深受学员好评",
        },
        {
          img: require("../assets/jeTeacher.png"),
          name: "六六老师",
          nickname: "",
          course: "经典课程：《基础护理学》《护理学导论》",
          zili: [
            "沃米护考特聘讲师",
            "线下护考面授培训经验8年",          
          ],
          fengge:
            "讲课思路缜密，善于运用举例、对比分析及口诀记忆等方法帮助学员短期突破重难点。",
        },
        {
          img: require("../assets/xlTeacher.png"),
          name: "小鹿老师",
          nickname: "",
          course: "",
          zili: [
            "临床工作经验11年",
            "北京协和医学院  主攻主管护师方向",
            "从事医学考试培训教学工作多年",
            "精准把握医学考试命题重点与考察方向",
          ],
          fengge:
            "严谨的教风中不乏风趣，提倡理解性记忆与趣味化记忆相结合，深入浅出、生动形象",
        },
      ],
      messageType: null,
      nameValue: "",
      phoneValue: "",
      msgValue: "",
      Mname: "",
      Mphone: "",
      Memail: "",
      videoType: 1,
      videourl: "//player.bilibili.com/player.html?bvid=BV13e411o7eV&page=1",
      addr: [
        "北京",
        "广东",
        "江苏",
        "山东",
        "浙江",
        "安徽",
        "四川",
        "河南",
        "天津",
        "湖南",
        "湖北",
        "重庆",
        "福建",
        "陕西",
        "河北",
        "上海",
        "吉林",
        "辽宁",
        "甘肃",
        "山西",
        "海南",
        "江西",
        "黑龙江",
        "更多",
      ],
      aNmae: "",
      scrollY: 0,
      Tcar: [
        {
          img: require("../assets/jjTeacher1.png"),
          name: "洋洋老师",
          indexs: 1,
        },
        {
          img: require("../assets/jeTeacher1.png"),
          name: "六六老师",
          indexs: 2,
        },
        {
          img: require("../assets/xlTeacher1.png"),
          name: "小鹿老师",
          indexs: 3,
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.scrollY =
        document.documentElement.scrollTop || document.body.scrollTop;
    });
    this.messageType = setInterval(() => {
      let iconDiv1 = document.getElementById("iconDiv1");
      if (iconDiv1) {
        iconDiv1.style.display = "none";
        clearInterval(this.messageType);
      }
    });
  },
  methods: {
    goCeping() {
      window.open("https://appKM3wSxwp5419.h5.xiaoeknow.com/p/t/v1/data-center/h5_form/page/submit_info/form_LKgAy1sYGmlMRR");
    },
    addrName(item) {
      console.log(item);
      this.aNmae = item;
    },
    carImg(index) {
      let car = [
        {
          name: "多巴胺老师",
          img: require("../assets/zzTeacher1.png"),
          indexs: 0,
        },
        {
          img: require("../assets/jjTeacher1.png"),
          name: "洋洋老师",
          indexs: 1,
        },
        {
          img: require("../assets/jeTeacher1.png"),
          name: "六六老师",
          indexs: 2,
        },
        {
          img: require("../assets/xlTeacher1.png"),
          name: "小鹿老师",
          indexs: 3,
        },
      ];
      for (let i = 0; i < car.length; i++) {
        if (car[i].indexs === index) {
          car.splice(i, 1);
        }
      }
      this.Tcar = car;
      this.$refs.carousel.setActiveItem(index);
    },
    videoTab(value) {
      this.videoType = value;
      switch (value) {
        case 1:
          this.videourl =
            "//player.bilibili.com/player.html?bvid=BV13e411o7eV&page=1";
          break;
        case 2:
          this.videourl =
            "//player.bilibili.com/player.html?bvid=BV1iN411L71h&page=1";
          break;
        case 3:
          this.videourl =
            "//player.bilibili.com/player.html?bvid=BV1Lj4115755&page=1";
          break;
        case 4:
          this.videourl =
            "//player.bilibili.com/player.html?bvid=BV1yN411L7hn&page=1";
          break;
        case 5:
          this.videourl =
            "//player.bilibili.com/player.html?bvid=BV1Gg4y1f7mw&page=1";
          break;
      }
    },
    goSubmit(item) {
      let obj = {};
      let message = "成功";
      if (item == "获取查询信息") {
        message = "提交成功";
        obj = {
          phoneNum: this.phone,
          province: this.province,
          workYear: this.province2,
          educationBackground: this.province1,
        };
        if (
          this.phone == "" ||
          this.province == "" ||
          this.province1 == "" ||
          this.province2 == ""
        ) {
          this.$message({
            message: "请检查所填信息是否为空",
            type: "error",
          });
          return;
        }
      } else if (item == "一键查询") {
        message = "提交成功 查询结果将与10分钟内下发到您的手机，请注意查收";
        obj = {
          phoneNum: this.input,
        };
        if (this.input == "") {
          this.$message({
            message: "手机号不能为空",
            type: "error",
          });
          return;
        }
      } else if (item == "立即下载" || item == "立即下载1") {
        if (item == "立即下载1") {
          message = `您已预约成功！我们的指导老师将于1-2个工作日内与您联系确认开营训练；请注意接听电话。`;
        } else {
          message =
            "提交成功！我们的老师将于1-2个工作日内与您联系发送资料，请耐心等待。";
        }

        obj = {
          name: this.Mname,
          phoneNum: this.Mphone,
          email: this.Memail,
        };
        if (this.dialogVisibleType == 1) {
          if (this.Mphone == "") {
            this.$message({
              message: "手机号不能为空",
              type: "error",
            });
            return;
          }
        } else {
          if (this.Mphone == "") {
            this.$message({
              message: "手机号不能为空",
              type: "error",
            });
            return;
          }
          if (this.Memail == "") {
            this.$message({
              message: "邮箱不能为空",
              type: "error",
            });
            return;
          }
        }
      } else {
        message = "提交成功！稍后我们的老师将与您联系下发资料";
        obj = {
          name: this.nameValue,
          phoneNum: this.phoneValue,
          email: this.msgValue,
        };
        if (this.phoneValue == "" || this.msgValue == "") {
          this.$message({
            message: "请检查所填信息是否为空",
            type: "error",
          });
          return;
        }
      }
      if (obj.phoneNum) {
        let re = /^1\d{10}$/;
        if (!re.test(obj.phoneNum)) {
          this.$message({
            message: "请检查手机号格式是否正确",
            type: "error",
          });
          return;
        }
      }
      if (obj.email) {
        let re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        if (!re.test(obj.email)) {
          this.$message({
            message: "请检查邮箱格式是否正确",
            type: "error",
          });
          return;
        }
      }

      this.$post("/marketing", obj, (res) => {
        this.dialogVisible = false;
        this.$message({
          message: message,
          type: "success",
        });
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    service(value) {
      this.dialogVisibleType = value;
      this.dialogVisible = true;
    },
    /* 返回顶部 */
    goTop() {
      scrollTo(0, 0);
    },
    goDom(item) {
      document.querySelector(item).scrollIntoView(true);
    },
    goMessage() {
      var _53 = $53.createApi(); /*开发者文档1.1 创建SDK资源对象*/
      _53.push("cmd", "kfclient"); /*开发者文档1.2 打开pc访客端*/
      _53.push("type", "popup");
      _53.query();
    },
  },
};
</script>
<style lang='scss' scoped>
.content::v-deep {
  // white-space: nowrap;
  #hoverColor:hover {
    background: rgba(242, 102, 66, 1);
    color: rgba(255, 255, 255, 1);
  }
  #buttonColor:hover {
    background: rgba(217, 91, 59, 1);
  }
  #buttonColorb:hover {
    background: rgba(58, 84, 225, 1);
  }
  .width_1200 {
    width: 1061px;
    margin: auto;
  }
  .topnav {
    height: 423px;
    background: linear-gradient(
      180deg,
      rgba(27, 62, 249, 0.9) 90%,
      rgba(70, 94, 251, 1) 100%
    );
    color: #ffffff;
    button {
      color: #ffffff;
    }
    .color {
      color: rgba(21, 41, 85, 1);
      button {
        color: rgba(21, 41, 85, 1);
        background: #f0f0fb !important;
      }
    }
    nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // color: #ffffff;
      padding: 20px 0;
      width: 1061px;
      margin: auto;
      .logo {
        display: flex;
        align-items: center;
      }
      ul {
        list-style: none;
        display: flex;
        li {
          padding: 0 18px;
          cursor: pointer;
        }
      }
      .dropdownBtn {
        display: flex;
        align-items: center;
        .button {
          padding: 6px 8px;
          background: #415efb;
          border-radius: 6px;
          // color: #ffffff;
        }
        .phone {
          display: flex;
          align-items: center;
          // img {
          //   margin-right: -8px;margin-left: 15px;
          // }
          span {
            font-weight: 600;
          }
        }
      }
    }
    .top_info {
      display: flex;
      position: relative;
      margin-top: 68px;
      // background: red;
      .Left_ {
        width: 240px;
        height: 283px;
        position: fixed;
        margin-top: 60px;
        left: 30px;
        background-image: url("../assets/ceping.png");
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        background-size: cover;
        background-position: center center;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        .Lefft_but {
          width: 140px;
          height: 40px;
          background-image: url("../assets/cepingbut.png");
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          background-size: cover;
          background-position: center center;
          margin-bottom: 30px;
          margin-right: 20px;
          cursor: pointer;
        }
      }
      .left {
        .bt {
          margin-bottom: 20px;
          margin-left: 15px;
          span {
            color: #ffffff;
            font-size: 24px;
            font-weight: 600;
          }
          span:first-child {
            margin-right: 20px;
          }
        }
        img {
          display: block;
          margin-left: -10px;
        }
        .btns {
          display: flex;
          div {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #ffffff;
            border-radius: 5px;
            border: 1px solid #f26642;
            color: #f26642;
            font-size: 16px;
            cursor: pointer;
          }
          div:nth-child(2) {
            margin: 0 20px;
          }
        }
        p {
          margin-top: 8px;
          font-size: 16px;
          color: #ffffff;
          margin-left: 20px;
          margin-bottom: 40px;
        }
      }
      .right {
        position: absolute;
        right: 54px;
        img {
          width: 485px;
          height: 423px;
        }
      }
    }
  }
  .service {
    margin-top: 125px;
    .border_bt {
      border-bottom: 1px solid rgba(118, 119, 146, 0.1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 42px;
      span {
        font-size: 16px;
        color: #000000;
        font-weight: 600;
      }
    }
    .title {
      font-size: 32px;
      color: #152955;
      font-weight: 600;
      text-align: center;
    }
    .service_info {
      display: flex;
      margin-top: 40px;
      .left {
        > div {
          width: 300px;
          height: 210px;
          background: #ffffff;
          box-shadow: 0px 0px 14px 0px rgba(66, 83, 99, 0.1);
          border-radius: 8px;
        }
        > div:first-child {
          margin-bottom: 10px;
        }
        .left_top {
          padding: 0 20px;
          box-sizing: border-box;

          .left_top_btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            div {
              width: 160px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              background: #f26642;
              border-radius: 20px;
              color: #ffffff;
              font-size: 16px;
              cursor: pointer;
            }
            div:first-child {
              margin: 30px 0 20px 0;
            }
          }
        }
        .guidance {
          padding: 20px;
          box-sizing: border-box;
          .guidance_bt {
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            color: #000000;
            margin-bottom: 20px;
            > span {
              font-weight: 600;
            }
            i {
              color: #415efb;
            }
          }
          .menu_btn {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .menu_btn_item {
              width: 80px;
              height: 36px;
              line-height: 36px;
              text-align: center;
              background: rgba(65, 94, 251, 0.08);
              border-radius: 6px;
              color: #415efb;
              font-size: 14px;
              margin-bottom: 14px;
              cursor: pointer;
            }
          }
        }
      }
      .center {
        width: 440px;
        height: 430px;
        background: #ffffff;
        box-shadow: 0px 0px 14px 0px rgba(66, 83, 99, 0.1);
        border-radius: 8px;
        border: 1px solid #ffffff;
        margin: 0 10px;
        padding: 0 20px;
        box-sizing: border-box;
        .answer_box {
          margin-top: 24px;
          .answer_item {
            font-size: 14px;
            color: #767792;
            margin-bottom: 20px;
            cursor: pointer;
            white-space: nowrap;
          }
        }
      }
      .right {
        width: 300px;
        height: 430px;
        background: #ffffff;
        box-shadow: 0px 0px 14px 0px rgba(66, 83, 99, 0.1);
        border-radius: 8px;
        border: 1px solid #ffffff;
        padding: 0 20px;
        box-sizing: border-box;
        .load_box {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 10px;
          .load_item {
            width: 122px;
            height: 34px;
            border-radius: 6px;
            border: 1px solid #dfe0e6;
            color: #152955;
            font-size: 14px;
            justify-content: center;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            cursor: pointer;
            img {
              margin-right: 10px;
            }
          }
        }
        .from_box {
          > div {
            width: 260px;
            height: 38px;
            background: #f8f8fb;
            border-radius: 6px;
            padding: 8px 0 8px 15px;
            box-sizing: border-box;
            margin-bottom: 10px;
            span {
              color: #152955;
            }
            input {
              outline: none;
              border: none;
              background: #f8f8fb;
            }
          }
          .fromBtn {
            background: #f26540;
            border-radius: 6px;
            border-color: #f26540;
            width: 100%;
          }
        }
      }
    }
  }
  .query {
    height: 270px;
    margin-top: 75px;
    background: url("../assets/query.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .query_text1 {
      font-size: 42px;
      font-weight: 800;
      color: #fee83c;
      margin: 64px 0 16px 0;
    }
    .query_text2 {
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
    }
    .query_input {
      width: 870px;
      margin-top: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .select_ {
        display: flex;
        align-items: center;
        .select_div {
          background: #ffffff;
          box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          width: 134px;
          height: 36px;
          margin-right: 20px;
        }
      }
      .select_phone {
        display: flex;
        align-items: center;
        input {
          width: 198px;
          height: 36px;
          background: #ffffff;
          box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
        button {
          width: 125px;
          height: 36px;
          background: #f26642;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          color: #ffffff;
          padding-left: 15px;
          line-height: 13px;
          margin-left: 10px;
        }
      }
    }
  }
  .prepare {
    margin-top: 75px;
    .prepare_text {
      display: block;
      width: 100%;
      text-align: center;
      font-size: 32px;
      font-weight: 500;
      color: #152955;
    }
    .prepare_border {
      width: 100%;
      height: 1px;
      background: #e4e9ff;
      border: 1px solid #e4e9ff;
      margin-top: 18px;
      div {
        width: 117px;
        height: 1px;
        border: 3px solid #415efb;
        background: #415efb;
        margin: auto;
        margin-top: -3px;
        border-radius: 5px;
      }
    }
    .prepare_minText {
      font-size: 16px;
      font-weight: 400;
      color: #767792;
      display: block;
      text-align: center;
      margin-top: 5px;
    }
    .prepare_content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 40px;
      .div {
        background: #ffffff;
        box-shadow: 0px 0px 14px 0px rgba(66, 83, 99, 0.1);
        border-radius: 8px;
        border: 1px solid #ffffff;
      }
      .synopsis_left,
      .synopsis_right {
        width: 520px;
        height: 324px;
      }
      .synopsis_left {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        .synopsis_left-box {
          width: 150px;
          height: 105px;
          .box_imgT {
            display: flex;
            align-items: center;
            img {
              width: 56px;
              height: 56px;
            }
            .span {
              display: flex;
              font-size: 14px;
              flex-direction: column;
              font-weight: 400;
              color: #152955;
              margin-left: 11px;
              span:nth-child(2) {
                margin-top: 10px;
              }
            }
          }
          .box_bottom {
            width: 129px;
            height: 30px;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            line-height: 30px;
            margin-top: 20px;
            cursor: pointer;
          }
          #box_bottom2 {
            background: rgba(132, 250, 127, 0.3);
          }

          #box_bottom1 {
            background: rgba(255, 222, 61, 0.3);
          }
          #box_bottom1:hover {
            background: rgba(242, 235, 204, 1);
          }
          #box_bottom2:hover {
            background: rgba(218, 241, 217, 1);
          }

          #box_bottom3 {
            background: rgba(35, 189, 251, 0.3);
          }
          #box_bottom3:hover {
            background: rgba(200, 229, 241, 1);
          }
          #box_bottom4 {
            background: rgba(254, 89, 108, 0.3);
          }
          #box_bottom4:hover {
            background: rgba(255, 222, 226, 1);
          }
        }
        .synopsis_left_border {
          width: 1px;
          height: 65px;
          opacity: 0.38;
          background: #d5d6de;
          border: 1px solid #d5d6de;
        }
      }
      .synopsis_right {
        .synopsis_right_title {
          display: block;
          width: 100%;
          text-align: center;
          font-size: 22px;
          font-weight: 500;
          color: #000000;
          margin-top: 18px;
        }
        .synopsis_right_content {
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 20px;
          ._content_left {
            width: 159px;
            ._content_left_box {
              width: 159px;
              height: 146px;
              border-radius: 6px;
              border: 1px solid rgba(186, 187, 200, 0.33);
              ._left_box {
                width: 100%;
                height: 39px;
                background: #415efb;
                border-radius: 6px 6px 0px 0px;
                display: flex;
                align-items: center;
                justify-content: center;
                span {
                  font-size: 16px;
                  font-weight: bold;
                  color: #ffffff;
                  margin-left: 5px;
                }
                img {
                  width: 21px;
                  height: 24px;
                }
              }
              ._left_text {
                display: block;
                width: 127px;
                height: 95px;
                font-size: 14px;
                font-weight: 400;
                color: #152955;
                line-height: 23px;
                margin: auto;
                margin-top: 10px;
              }
            }
            input {
              width: 159px;
              height: 36px;
              background: #ffffff;
              box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1);
              border-radius: 4px;
              margin-top: 15px;
            }
            button {
              width: 159px;
              height: 36px;
              background: #f26642;
              border-radius: 4px;
              font-size: 16px;
              font-weight: 500;
              color: #ffffff;
              line-height: 0px;
              margin-top: 10px;
            }
          }
          ._content_right {
            width: 325px;
            height: 243px;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            ._right_text {
              width: 57px;
              height: 29px;
              background: #f0f3ff;
              border-radius: 4px;
              border: 1px solid rgba(65, 94, 251, 0.46);
              font-size: 14px;
              font-weight: 400;
              color: #152955;
              text-align: center;
              line-height: 29px;
              cursor: pointer;
              margin-bottom: 22px;
              margin-right: 5px;
            }
            ._right_text_option {
              width: 58px;
              height: 29px;
              background: #415efb;
              border-radius: 4px;
              border: 1px solid #415efb;
              font-size: 14px;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              line-height: 29px;
              cursor: pointer;
              margin-bottom: 22px;
              margin-right: 5px;
            }
          }
        }
      }
      .left {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: center;
        width: 280px;
        height: 564px;
        .left_title {
          width: 240px;
          margin: auto;
          border-bottom: 1px solid rgba(118, 119, 146, 0.1);
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 11px;
          padding-bottom: 5px;
          span {
            font-size: 16px;
            font-weight: 500;
            color: #000000;
          }
          img {
            width: 26px;
            height: 28px;
          }
        }
        .left_box_right {
          width: 221px;
          height: 94px;
          background: #f0f3ff;
          border-radius: 48px 2px 0px 2px;
          border: 2px solid rgba(65, 94, 251, 0.12);
          margin-top: 5px;
          margin-right: 35px;
          display: flex;
          align-items: center;
          .circle {
            width: 57px;
            height: 57px;
            background: #8699fc;
            box-shadow: 0px 0px 10px 0px rgba(65, 94, 251, 0.55);
            border-radius: 100%;
            margin-right: -38px;
            font-size: 24px;
            font-weight: 800;
            color: #ffffff;
            text-align: center;
            line-height: 57px;
            letter-spacing: 5px;
          }
          .left_box_text {
            width: 160px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-left: 30px;
            span:nth-child(1) {
              font-size: 14px;
              font-weight: bold;
              color: #415efb;
              margin-top: 4px;
            }
            span:nth-child(2) {
              font-size: 12px;
              font-weight: 400;
              color: #152955;
              line-height: 17px;
            }
          }
        }
        .left_box {
          width: 221px;
          height: 94px;
          background: #f0f3ff;
          border-radius: 2px 48px 0px 2px;
          border: 2px solid rgba(65, 94, 251, 0.12);
          margin-top: 17px;
          margin-left: 35px;
          display: flex;
          align-items: center;
          .circle {
            width: 57px;
            height: 57px;
            background: #8699fc;
            box-shadow: 0px 0px 10px 0px rgba(65, 94, 251, 0.55);
            border-radius: 100%;
            margin-left: -28.5px;
            font-size: 24px;
            font-weight: 800;
            color: #ffffff;
            text-align: center;
            line-height: 57px;
            letter-spacing: 5px;
          }
          .left_box_text {
            width: 160px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-left: 16px;
            span:nth-child(1) {
              font-size: 14px;
              font-weight: bold;
              color: #415efb;
              margin-top: 4px;
            }
            span:nth-child(2) {
              font-size: 12px;
              font-weight: 400;
              color: #152955;
              line-height: 17px;
            }
          }
        }
      }
      .right {
        width: 771px;
        height: 564px;
        .right_div_title {
          width: 731px;
          height: 30px;
          background: rgba(65, 94, 251, 0.63);
          border-radius: 4px;
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          text-align: center;
          line-height: 30px;
          margin: 21px auto 0 auto;
        }
        .right_div_title-li {
          width: 731px;
          height: 30px;
          background: rgba(65, 94, 251, 0.08);
          border-radius: 4px;
          display: flex;
          align-items: center;
          margin: 10px auto 0 auto;
          span {
            display: block;
            font-size: 14px;
            font-weight: 400;
            color: #152955;
            margin-left: 11px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-left: 21px;
          }
        }
        .right_div_promit {
          width: 731px;
          height: 151px;
          background: #ffffff;
          box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          border: 1px solid #d9d9d9;
          margin: 25px auto 0 auto;
          span {
            font-size: 14px;
            font-weight: 400;
            color: #767792;
            line-height: 24px;
            display: block;
            margin-right: 13px;
            margin-left: 16px;
          }
          span:nth-child(1) {
            margin-top: 19px;
            font-weight: 600;
          }
        }
        button {
          width: 159px;
          height: 36px;
          color: #ffffff;
          line-height: 0px;
          padding: 0;
          font-size: 16px;
          font-weight: 500;
          margin-top: 20px;
        }

        #buttonColor {
          background: #f26642;
        }
        #buttonColor:hover {
          background: rgba(217, 91, 59, 1);
        }
        #buttonColorb {
          background: #415efb;
        }
        #buttonColorb:hover {
          background: rgba(58, 84, 225, 1);
        }
      }
    }
    .know {
      margin-top: 41px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .knowimg {
        width: 465px;
        height: 412px;
      }
      .know_good {
        width: 577px;
        height: 412px;
        background: linear-gradient(180deg, #7497fd 0%, #405efa 100%);
        border-radius: 8px;
        box-sizing: border-box;
        padding: 40px 66px 0 93px;
        ._good_title {
          font-size: 36px;
          font-weight: bold;
          color: #ffffff;
          line-height: 54px;
          letter-spacing: 2px;
        }
        ._good_ul {
          width: 93%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 3px;
          ._good_ul_span {
            width: 345px;
            height: 42px;
            border-bottom: 1px dashed #ffffff;
            font-size: 16px;
            color: rgba(255, 255, 255, 1);
            text-align: left;
            line-height: 42px;
          }
          ._good_ul_li {
            width: 37px;
            height: 37px;
            background-color: rgba(255, 255, 255, 0.21);
            border-radius: 100%;
            div {
              width: 28px;
              height: 28px;
              background-color: rgba(255, 255, 255, 0.72);
              font-size: 20px;
              font-weight: 800;
              color: #415efb;
              border-radius: 100%;
              line-height: 28px;
              text-align: center;
              margin: auto;
              margin-top: 4.5px;
            }
          }
        }
      }
      .know_book {
        width: 1059px;
        height: 324px;
        background: #ffffff;
        box-shadow: 0px 0px 14px 0px rgba(66, 83, 99, 0.1);
        border-radius: 8px;
        border: 1px solid #ffffff;
        margin-top: 19px;
        img {
          width: 994px;
          height: 208px;
          margin: 13px 34px;
        }
        ._book_span {
          width: 994px;
          margin-left: 34px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            display: block;
            width: 157px;
            font-size: 14px;
            font-weight: 400;
            color: #152955;
            line-height: 14px;
            text-align: center;
          }
        }
        ._book_but {
          width: 994px;
          margin-left: 34px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 19px;
          div {
            width: 157px;
            display: flex;
            button {
              width: 84px;
              height: 30px;
              text-align: center;
              font-size: 12px;
              font-weight: 500;
              color: #ffffff;
              line-height: 0;
              padding-left: 10px;
            }
            button:nth-child(1) {
              background: rgba(242, 102, 66, 1);
            }
            button:nth-child(2) {
              background: rgba(65, 94, 251, 1);
            }
          }
        }
      }
    }
    .reference {
      width: 1059px;
      height: 650px;
      background: #ffffff;
      box-shadow: 0px 0px 14px 0px rgba(66, 83, 99, 0.1);
      border-radius: 8px;
      border: 1px solid #ffffff;
      margin-top: 40px;
      display: flex;

      .reference-left {
        width: 335px;
        margin-left: 20px;
        div {
          width: 337px;
          height: 1px;
          opacity: 0.21;
          background: #5065e4;
          border: 1px solid #5065e4;
        }
        .error {
          display: block;
          width: 336px;
          height: 43px;
          line-height: 43px;
          // text-align: center;
          margin-top: 6px;
          margin-bottom: 6px;
          font-size: 16px;
          font-weight: 500;
          background: rgba(230, 230, 235, 0.4);
          color: #152955;
          text-indent: 40px;
          cursor: pointer;
        }
        ._left_title_ {
          display: block;
          width: 335px;
          height: 57px;
          background: linear-gradient(180deg, #7697fd 0%, #415efb 100%);
          margin-top: 17px;
          font-size: 24px;
          font-weight: 800;
          color: #ffffff;
          line-height: 57px;
          text-align: center;
          border-radius: 4px;
          text-indent: 0px;
        }
        .title {
          display: block;
          font-size: 20px;
          font-weight: 500;
          color: #152955;
          margin-top: 15px;
          margin-bottom: 6px;
          text-align: left;
          background: none;
          text-indent: 0px;
        }
        button {
          width: 186px;
          height: 41px;
          background: #f26642;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          color: #ffffff;
          line-height: 0;
          margin-top: 23px;
          margin-left: 57px;
        }
        .option {
          background: rgba(65, 94, 251, 0.1);
          color: #415efb;
        }
      }
      .reference-right {
        width: 666px;
        margin-left: 20px;
        .video {
          width: 666px;
          height: 395px;
          border-radius: 8px;
          // border: 1px solid #415EFB;
        }
        ._right_bottom {
          width: 666px;
          height: 198px;
          background: rgba(135, 136, 160, 0.09);
          border-radius: 8px;
          margin-top: 25px;
          padding: 15px;
          box-sizing: border-box;
          ._bottom_title {
            width: 637px;
            height: 50px;
            background: url("../assets/bottoming.png") no-repeat;
            background-size: 100% 100%;
            font-size: 21px;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
            line-height: 50px;
          }
          ._bottom_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            flex-wrap: wrap;
            ._box {
              width: 185px;
              height: 40px;
              background: linear-gradient(156deg, #ffffff 0%, #ffffff 100%);
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px solid #415efb;
              margin-top: 10px;
              cursor: pointer;
              color: #152955;
              img {
                width: 32px;
                height: 30px;
              }
              div {
                display: flex;
                flex-direction: column;
                margin-left: 5px;
                span {
                  font-size: 12px;
                  font-weight: 400;
                }
              }
            }
            ._box:hover {
              color: rgba(65, 94, 251, 1) !important;
            }
          }
        }
      }
    }
    .wmImg {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 39px;
      img {
        width: 245px;
        height: 391px;
      }
    }
    .lastdiv {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 43px;
      img {
        width: 346px;
        height: 215px;
      }
    }
    .allNew {
      width: 1060px;
      height: 476px;
      background: #ffffff;
      box-shadow: 0px 0px 14px 0px rgba(66, 83, 99, 0.1);
      border-radius: 8px;
      box-sizing: border-box;
      padding: 20px;
      margin-top: 20px;
      .allnew1 {
        width: 100%;
        height: 100%;
        background: url("../assets/allNew1.png") no-repeat;
        background-size: 100% 100%;
      }
      .allnew2 {
        width: 100%;
        height: 100%;
        background: url("../assets/allNew2.png") no-repeat;
        background-size: 100% 100%;
      }
      .allnew3 {
        width: 100%;
        height: 100%;
        background: url("../assets/allNew3.png") no-repeat;
        background-size: 100% 100%;
      }
      .allnew4 {
        width: 100%;
        height: 100%;
        background: url("../assets/allNew4.png") no-repeat;
        background-size: 100% 100%;
      }
      button {
        width: 160px;
        height: 37px;
        background: #f26642;
        border-radius: 4px;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 0;
        border: none;
        margin-top: 347px;
        margin-left: 31px;
      }
    }
    .carousel {
      width: 1060px;
      height: 671px;
      background: #ffffff;
      box-shadow: 0px 0px 14px 0px rgba(66, 83, 99, 0.1);
      border-radius: 8px;
      border: 1px solid #ffffff;
      box-sizing: border-box;
      padding: 20px;
      margin-top: 40px;
      .carousel_content {
        width: 100%;
        height: 100%;
        background: #f3f3f6;
        border-radius: 8px;
        .car_box {
          width: 100%;
          height: 364px;
          .car_box_ {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 16px;
            display: flex;
            justify-content: space-between;
            .car_box_left {
              width: 282px;
              height: 318px;
              ._box_name {
                width: 214px;
                height: 67px;
                background: url("../assets/nameimg.png") no-repeat;
                background-size: 100% 100%;
                font-size: 18px;
                font-weight: bold;
                color: #ffffff;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                float: left;
                margin-left: 40px;
                margin-top: 280px;
              }
            }
            .car_box_right {
              width: 694px;
              height: 318px;
              background: #ffffff;
              box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1);
              border-radius: 4px;
              border: 1px solid #d9d9d9;
              box-sizing: border-box;
              padding: 17px 0 0 28px;
              ._right_title {
                font-size: 26px;
                font-weight: 500;
                color: #000000;
              }
              ._right_span {
                display: flex;
                margin-top: 10px;
                div {
                  span:nth-child(1) {
                    font-weight: 700;
                    color: rgba(21, 41, 85, 1);
                  }
                  span {
                    display: block;
                    font-size: 15px;
                    color: rgba(118, 119, 146, 1);
                    margin-top: 5px;
                  }
                }
                img {
                  width: 15px;
                  height: 21px;
                }
              }
            }
          }

          .el-carousel .el-carousel__indicators {
            display: none;
          }
        }
        .car_bottom {
          width: 100%;
          height: 210px;
          margin-top: 20px;
          box-sizing: border-box;
          padding: 0 16px 0 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .car_bot_img1 {
            width: 318px;
            height: 194px;
            // background: url("../assets/jeTeacher1.png") no-repeat;
            background-size: 100% 100%;
            div {
              width: 150px;
              height: 40px;
              background: url("../assets/nameimg1.png") no-repeat;
              font-size: 18px;
              font-weight: bold;
              color: #ffffff;
              line-height: 40px;
              float: left;
              text-indent: 30px;
              margin-left: 90px;
              margin-top: 170px;
            }
          }
          .imgt {
            background: url("../assets/jjTeacher1.png") no-repeat;
            background-size: 100% 100%;
          }
          .imgt1 {
            background: url("../assets/xlTeacher1.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .conditions {
    .conditions_content {
      margin-top: 39px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        width: 265px;
        height: 391px;
        background: #ffffff;
        box-shadow: 0px 0px 14px 0px rgba(66, 83, 99, 0.1);
        border-radius: 8px;
        border: 1px solid #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 244px;
          height: 141px;
          border-radius: 10px 10px 0 0;
          margin-top: 10px;
        }
        ._con_div {
          width: 100px;
          height: 100px;
          border-radius: 100%;
          border: none;
          background: url("../assets/log.png") no-repeat;
          background-size: 100% 100%;
          margin-top: -50px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            display: block;
            width: 36px;
            font-size: 18px;
            font-weight: bold;
            color: #415dfb;
          }
        }
        ._con_span {
          display: block;
          width: 186px;
          height: 104px;
          font-size: 14px;
          font-weight: 400;
          color: #152955;
          line-height: 20px;
          margin-top: 10px;
        }
        button {
          width: 186px;
          height: 36px;
          background: #415efb;
          color: #ffffff;
          line-height: 0;
        }
        ._con_spanlast {
          font-size: 14px;
          font-weight: 400;
          color: #152955;
          margin-top: 10px;
          span {
            cursor: pointer;
            color: rgba(65, 94, 251, 1);
            margin-left: 5px;
          }
        }
      }
      img {
        width: 206px;
        height: 390px;
      }
    }
  }
  .guard {
    height: 270px;
    background: url("../assets/guard.png");
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    margin-top: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      box-sizing: border-box;
      padding-left: 344px;
      img {
        width: 486px;
        height: 112px;
      }
      button {
        width: 160px;
        height: 46px;
        background: #f26642;
        border-radius: 4px;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 0;
        border: 0;
        margin-top: 15px;
        margin-left: 7px;
      }
    }
  }
  .bottomBox {
    width: 100%;
    height: 370px;
    background: url("../assets/BottomImg.png");
    margin-top: 74px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
  }
  .record {
    width: 814px;
    margin-top: 38px;
    font-size: 16px;
    font-weight: 400;
    color: #8a8888;
    padding-bottom: 41px;
    div:nth-child(1) {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    div:nth-child(2) {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 3px;
      img {
        width: 20px;
        height: 22px;
      }
    }
  }
  .follow {
    width: 120px;
    position: fixed;
    bottom: 60px;
    right: 30px;
    .follow_top {
      width: 120px;
      height: 334px;
      background: #f26540;
      border-radius: 6px;
      img {
        width: 90px;
        height: 90px;
        float: left;
        margin-top: -45px;
        margin-left: 15px;
      }
      .follow_span {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span {
          padding: 10px 0;
          border-bottom: 1px dashed #fff;
          color: #ffffff;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
    .follow_bottom {
      width: 120px;
      height: 52px;
      background: #f26540;
      border-radius: 6px;
      margin-top: 15px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 17px;
        height: 18px;
      }
      span {
        font-size: 14px;
        color: #ffffff;
        font-weight: 400;
        // margin-top: 10px;
      }
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    display: none;
  }
  .info_popup {
    width: 393px;
    // height: 421px;
    background: #ffffff;
    box-shadow: 0px 0px 26px 0px rgba(0, 0, 0, 0.14);
    border-radius: 12px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 200px;
    .off {
      width: 20px;
      height: 20px;
      float: right;
      z-index: 99;
      position: absolute;
      margin-top: 0px;
      margin-left: 330px;
      cursor: pointer;
    }
    img {
      width: 395px;
      height: 220px;
      margin-top: -100px;
    }
    .span {
      width: 284px;
      height: 28px;
      background: rgba(254, 107, 107, 0.1);
      border-radius: 7px;
      font-size: 14px;
      font-weight: 400;
      color: #262626;
      text-align: center;
      line-height: 28px;
      margin-top: 20px;
      span {
        color: rgba(254, 107, 107, 1);
      }
    }
    input {
      width: 288px;
      height: 38px;
      background: rgba(241, 241, 247, 0.5);
      border-radius: 6px;
      border: none;
      padding-left: 14px;
      box-sizing: border-box;
      margin-top: 20px;
    }
    button {
      width: 159px;
      height: 41px;
      background: #415efb;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      margin-top: 16px;
      margin-bottom: 22px;
    }
  }
}
</style>